import React, { useMemo } from 'react';
import { Checkbox, MenuItem, TextField, Typography, WithInfoIcon } from 'seagull';
import styles from "./AmendmentsApprovalMethodField.module.scss";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { getAllAutoApprovalDays, getAutoApprovalRange, isAmendmentAutoApprovalValid } from "../../../business-logic/amendmentsAutoApproval";
import { numberAndUnit } from "../../../infra/utils";
export function validateAmendmentsApprovalMethod(enabled, noticePeriod, EXTEND_AMENDMENTS_AUTO_APPROVAL) {
  return !enabled || !!noticePeriod && isAmendmentAutoApprovalValid(noticePeriod, EXTEND_AMENDMENTS_AUTO_APPROVAL);
}
export function AmendmentsApprovalMethodField(props) {
  const {
    enabled,
    noticePeriod,
    onToggle,
    onChangePeriod
  } = props;
  const {
    EXTEND_AMENDMENTS_AUTO_APPROVAL = false
  } = useFeatureFlags();
  const {
    minDays,
    maxDays
  } = getAutoApprovalRange(EXTEND_AMENDMENTS_AUTO_APPROVAL);
  const dayOptions = useMemo(() => getAllAutoApprovalDays(EXTEND_AMENDMENTS_AUTO_APPROVAL).map(value => ({
    value,
    text: numberAndUnit(value, 'day'),
    testid: "auto-approval-period-".concat(value)
  })), [EXTEND_AMENDMENTS_AUTO_APPROVAL]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles.toggleBlock
  }, /*#__PURE__*/React.createElement(WithInfoIcon, {
    info: "Amendments will take effect automatically if the client doesn't decline within the set time period. Amended invoices issued during notice period will require client approval."
  }, /*#__PURE__*/React.createElement(Checkbox, {
    checked: enabled,
    onChange: e => onToggle(e.currentTarget.checked),
    "data-testid": "auto-approval-toggle"
  }, /*#__PURE__*/React.createElement(Typography, null, "Enable amendment auto-approval with notice period")))), enabled && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.periodInput
  }, /*#__PURE__*/React.createElement(TextField, {
    select: true,
    label: "Notice period",
    value: noticePeriod,
    menuMaxHeight: 220,
    testid: "auto-approval-period",
    onChange: e => onChangePeriod(Number.parseInt(e.target.value))
  }, dayOptions.map(_ref => {
    let {
      value,
      text,
      testid
    } = _ref;
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: value,
      value: '' + value,
      "data-testid": testid
    }, text);
  }))), !validateAmendmentsApprovalMethod(enabled, noticePeriod, EXTEND_AMENDMENTS_AUTO_APPROVAL) && /*#__PURE__*/React.createElement(Typography, {
    skin: "error",
    variant: "paragraph2",
    "data-testid": "auto-approval-error"
  }, "Notice period must be between ", minDays, " and ", maxDays, " days")));
}